module.exports = "<div class=\"col-seleccion\">\n  <ticketing-stepper-auditorio></ticketing-stepper-auditorio>\n  <router-outlet></router-outlet>\n</div>\n"